export default __webpack_public_path__ + "static/media/LogoEquals9.4f3fb617.png";